import React, { JSX } from "react";


const InformationOval = ({information}:{information: string | number | JSX.Element}) => {

    if (!information) {
        return <></>
    }
    return (
        <div className={`information-oval`} >
            {information}        
        </div>
    );
};

export default InformationOval